import React from 'react';
import cn from 'classnames';
import { Checkbox } from '@alfalab/core-components-checkbox/esm';
import { CheckmarkMIcon } from '@alfalab/icons-glyph/CheckmarkMIcon';

var styles = {"checkmark":"select__checkmark_opbne","start":"select__start_opbne","center":"select__center_opbne","single":"select__single_opbne","selected":"select__selected_opbne"};
require('./index.css')

var BaseCheckmark = function (_a) {
    var _b;
    var selected = _a.selected, _c = _a.disabled, disabled = _c === void 0 ? false : _c, className = _a.className, multiple = _a.multiple, _d = _a.align, align = _d === void 0 ? 'center' : _d;
    var checkmarkClassNames = cn(styles.checkmark, styles[align], className, (_b = {},
        _b[styles.single] = !multiple,
        _b[styles.selected] = selected,
        _b));
    return multiple ? (React.createElement(Checkbox, { checked: selected, disabled: disabled, className: checkmarkClassNames, size: 'm', hiddenInput: true })) : (React.createElement(CheckmarkMIcon, { className: checkmarkClassNames }));
};

export { BaseCheckmark };
